var _style, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSUltrasonic({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "2330.575 6196.231 83.275 83.275",
    id: "svg5190",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", {
    id: "defs5133"
  }, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "guld",
    className: "cls-1",
    cx: 6.977,
    cy: 6.977,
    r: 6.977,
    style: {
      fill: "#f2f2f2"
    }
  })), _style || (_style = /*#__PURE__*/React.createElement("style", {
    id: "style5129"
  }, ".cls-1{fill:#f2f2f2}.cls-3{stroke:rgba(242,242,242,.5);stroke-width:.25px}.cls-4{fill:#931f1f}.cls-5{fill:#9d761f}.cls-6{clip-path:url(#clip-path)}.cls-7{stroke:none}.cls-8{fill:none}"))), /*#__PURE__*/React.createElement("g", {
    id: "ultra_sonic",
    "data-name": "ultra sonic",
    transform: "translate(1222 5578.194)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_1",
    "data-name": "Rectangle 1",
    transform: "translate(1131.024 643.596)",
    style: {
      fill: "#292929"
    },
    d: "M0 0h43.382v31.247H0z"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_2",
    "data-name": "Rectangle 2",
    transform: "translate(1138.609 650.573)",
    d: "M0 0h25.331v17.595H0z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "eye1",
    transform: "translate(1108.575 642.231)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "sort",
    className: "cls-3",
    style: {
      strokeWidth: ".25px"
    }
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-7",
    cx: 17.444,
    cy: 17.444,
    id: "ellipse5137",
    r: 17.444,
    style: {
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-8",
    cx: 17.444,
    cy: 17.444,
    id: "ellipse5139",
    r: 17.319,
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    id: "r\\xF8d",
    className: "cls-4",
    cx: 10.77,
    cy: 10.77,
    transform: "translate(6.674 6.674)",
    r: 10.77,
    style: {
      fill: "#931f1f"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    id: "guld-3",
    "data-name": "guld",
    className: "cls-5",
    cx: 8.039,
    cy: 8.039,
    transform: "translate(9.404 9.404)",
    r: 8.039,
    style: {
      fill: "#9d761f"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    id: "guld-4",
    "data-name": "guld",
    className: "cls-1",
    cx: 6.977,
    cy: 6.977,
    transform: "translate(10.466 10.466)",
    r: 6.977,
    style: {
      fill: "#f2f2f2"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_5",
    "data-name": "Group 5",
    transform: "translate(10.466 10.466)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_8",
    "data-name": "Mask Group 8",
    className: "cls-6",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_17",
    "data-name": "Group 17",
    transform: "rotate(-30 2.416 14.943)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_84",
    "data-name": "Rectangle 84",
    className: "cls-5",
    transform: "translate(2.048)",
    style: {
      fill: "#9d761f"
    },
    d: "M0 0h.607v22.791H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_91",
    "data-name": "Rectangle 91",
    className: "cls-5",
    transform: "rotate(-90 10.049 10.049)",
    style: {
      fill: "#9d761f"
    },
    d: "M0 0h.607v22.507H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_85",
    "data-name": "Rectangle 85",
    className: "cls-5",
    transform: "translate(4.93)",
    style: {
      fill: "#9d761f"
    },
    d: "M0 0h.607v22.791H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_97",
    "data-name": "Rectangle 97",
    className: "cls-5",
    transform: "rotate(-90 8.608 8.608)",
    style: {
      fill: "#9d761f"
    },
    d: "M0 0h.607v22.507H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_86",
    "data-name": "Rectangle 86",
    className: "cls-5",
    transform: "translate(7.812)",
    style: {
      fill: "#9d761f"
    },
    d: "M0 0h.607v22.791H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_96",
    "data-name": "Rectangle 96",
    className: "cls-5",
    transform: "rotate(-90 7.167 7.167)",
    style: {
      fill: "#9d761f"
    },
    d: "M0 0h.607v22.507H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_87",
    "data-name": "Rectangle 87",
    className: "cls-5",
    transform: "translate(10.694)",
    style: {
      fill: "#9d761f"
    },
    d: "M0 0h.607v22.791H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_95",
    "data-name": "Rectangle 95",
    className: "cls-5",
    transform: "rotate(-90 5.726 5.726)",
    style: {
      fill: "#9d761f"
    },
    d: "M0 0h.607v22.507H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_88",
    "data-name": "Rectangle 88",
    className: "cls-5",
    transform: "translate(13.576)",
    style: {
      fill: "#9d761f"
    },
    d: "M0 0h.607v22.791H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_94",
    "data-name": "Rectangle 94",
    className: "cls-5",
    transform: "rotate(-90 4.285 4.285)",
    style: {
      fill: "#9d761f"
    },
    d: "M0 0h.607v22.507H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_89",
    "data-name": "Rectangle 89",
    className: "cls-5",
    transform: "translate(16.458)",
    style: {
      fill: "#9d761f"
    },
    d: "M0 0h.607v22.791H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_93",
    "data-name": "Rectangle 93",
    className: "cls-5",
    transform: "rotate(-90 2.844 2.844)",
    style: {
      fill: "#9d761f"
    },
    d: "M0 0h.607v22.507H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_90",
    "data-name": "Rectangle 90",
    className: "cls-5",
    transform: "translate(19.34)",
    style: {
      fill: "#9d761f"
    },
    d: "M0 0h.607v22.791H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_92",
    "data-name": "Rectangle 92",
    className: "cls-5",
    transform: "rotate(-90 1.403 1.403)",
    style: {
      fill: "#9d761f"
    },
    d: "M0 0h.607v22.507H0z"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "eye2",
    transform: "translate(1156.962 642.231)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "sort-2",
    "data-name": "sort",
    className: "cls-3",
    style: {
      strokeWidth: ".25px"
    }
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-7",
    cx: 17.444,
    cy: 17.444,
    id: "ellipse5163",
    r: 17.444,
    style: {
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-8",
    cx: 17.444,
    cy: 17.444,
    id: "ellipse5165",
    r: 17.319,
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    id: "r\\xF8d-2",
    "data-name": "r\\xF8d",
    className: "cls-4",
    cx: 10.77,
    cy: 10.77,
    transform: "translate(6.674 6.674)",
    r: 10.77,
    style: {
      fill: "#931f1f"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    id: "guld-5",
    "data-name": "guld",
    className: "cls-5",
    cx: 8.039,
    cy: 8.039,
    transform: "translate(9.404 9.404)",
    r: 8.039,
    style: {
      fill: "#9d761f"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    id: "guld-6",
    "data-name": "guld",
    className: "cls-1",
    cx: 6.977,
    cy: 6.977,
    transform: "translate(10.466 10.466)",
    r: 6.977,
    style: {
      fill: "#f2f2f2"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_18",
    "data-name": "Group 18",
    transform: "translate(10.466 10.466)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_8-2",
    "data-name": "Mask Group 8",
    className: "cls-6",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_17-2",
    "data-name": "Group 17",
    transform: "rotate(-30 2.416 14.943)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_84-2",
    "data-name": "Rectangle 84",
    className: "cls-5",
    transform: "translate(2.048)",
    style: {
      fill: "#9d761f"
    },
    d: "M0 0h.607v22.791H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_91-2",
    "data-name": "Rectangle 91",
    className: "cls-5",
    transform: "rotate(-90 10.049 10.049)",
    style: {
      fill: "#9d761f"
    },
    d: "M0 0h.607v22.507H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_85-2",
    "data-name": "Rectangle 85",
    className: "cls-5",
    transform: "translate(4.93)",
    style: {
      fill: "#9d761f"
    },
    d: "M0 0h.607v22.791H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_97-2",
    "data-name": "Rectangle 97",
    className: "cls-5",
    transform: "rotate(-90 8.608 8.608)",
    style: {
      fill: "#9d761f"
    },
    d: "M0 0h.607v22.507H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_86-2",
    "data-name": "Rectangle 86",
    className: "cls-5",
    transform: "translate(7.812)",
    style: {
      fill: "#9d761f"
    },
    d: "M0 0h.607v22.791H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_96-2",
    "data-name": "Rectangle 96",
    className: "cls-5",
    transform: "rotate(-90 7.167 7.167)",
    style: {
      fill: "#9d761f"
    },
    d: "M0 0h.607v22.507H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_87-2",
    "data-name": "Rectangle 87",
    className: "cls-5",
    transform: "translate(10.694)",
    style: {
      fill: "#9d761f"
    },
    d: "M0 0h.607v22.791H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_95-2",
    "data-name": "Rectangle 95",
    className: "cls-5",
    transform: "rotate(-90 5.726 5.726)",
    style: {
      fill: "#9d761f"
    },
    d: "M0 0h.607v22.507H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_88-2",
    "data-name": "Rectangle 88",
    className: "cls-5",
    transform: "translate(13.576)",
    style: {
      fill: "#9d761f"
    },
    d: "M0 0h.607v22.791H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_94-2",
    "data-name": "Rectangle 94",
    className: "cls-5",
    transform: "rotate(-90 4.285 4.285)",
    style: {
      fill: "#9d761f"
    },
    d: "M0 0h.607v22.507H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_89-2",
    "data-name": "Rectangle 89",
    className: "cls-5",
    transform: "translate(16.458)",
    style: {
      fill: "#9d761f"
    },
    d: "M0 0h.607v22.791H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_93-2",
    "data-name": "Rectangle 93",
    className: "cls-5",
    transform: "rotate(-90 2.844 2.844)",
    style: {
      fill: "#9d761f"
    },
    d: "M0 0h.607v22.507H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_90-2",
    "data-name": "Rectangle 90",
    className: "cls-5",
    transform: "translate(19.34)",
    style: {
      fill: "#9d761f"
    },
    d: "M0 0h.607v22.791H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_92-2",
    "data-name": "Rectangle 92",
    className: "cls-5",
    transform: "rotate(-90 1.403 1.403)",
    style: {
      fill: "#9d761f"
    },
    d: "M0 0h.607v22.507H0z"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSUltrasonic);
export default __webpack_public_path__ + "static/media/sUltrasonic.b9532e97bde2e7e50fe28a6d2c9c276e.svg";
export { ForwardRef as ReactComponent };